"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SALES_DASHBOARD_POWER_EMAILS = exports.SALES_DASHBOARD_ALLOWED_EMAILS = void 0;
exports.isSalesDashboardAllowed = isSalesDashboardAllowed;
exports.isSalesDashboardPowerUser = isSalesDashboardPowerUser;
/**
 * Emails allowed to access the internal sales-call review dashboard during the
 * pilot. Shared by the backend gate and the frontend page so the two can't
 * drift as access widens. The backend additionally requires NewForm staff.
 */
exports.SALES_DASHBOARD_ALLOWED_EMAILS = [
    "ty@newform.com",
    "hamza@newform.com",
    "alec@newform.com",
    "andrew@newform.com",
    "erika@newform.com",
    "asif@newform.com",
    "manuel@newform.com",
    "joitchie@newform.com",
];
function isSalesDashboardAllowed(email) {
    if (!email)
        return false;
    return exports.SALES_DASHBOARD_ALLOWED_EMAILS.includes(email.toLowerCase());
}
/**
 * Power users who get the admin-only controls (manual re-analyze, debug view).
 * A subset of the access allowlist.
 */
exports.SALES_DASHBOARD_POWER_EMAILS = [
    "manuel@newform.com",
    "ty@newform.com",
    "alec@newform.com",
];
function isSalesDashboardPowerUser(email) {
    if (!email)
        return false;
    return exports.SALES_DASHBOARD_POWER_EMAILS.includes(email.toLowerCase());
}
